import React from 'react';
import EndOfDay from '~Scenes/EndOfDay';
import { usePage } from '~Scenes/Handy/Context/PageProvider';

const EndOfDayWrapper: React.FC = () => {
  const { navigateTo } = usePage();

  return <EndOfDay isHandy onCompleted={() => navigateTo('home')} />;
};

export default EndOfDayWrapper;
